import { DefaultLayout } from "~/layouts/DefaultLayout";
import { MetaHeader } from "~/components/MetaHeader";
import { hashtags } from "~/constants";
import { Link } from "remix";

const Area: React.VFC = () => {
    return (
        <>
            <MetaHeader title={"ハッシュタグ検索 - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"data.article.shop_description"} />

            <DefaultLayout>
                {/* apiで全体の数を表示するのも良い(開発アイデア) */}
                <h1 className="category_title">ハッシュタグから選ぶ</h1>
                <div className="hashtag_list">
                    <ul>
                        {hashtags.map((hashtag) => {
                            return (
                                <Link to={`/hashtags/detail?hashtag_id=${hashtag.id}`}>
                                    <li key={hashtag.id}>
                                        {hashtag.name}
                                    </li>
                                </Link>
                            );
                        })}
                    </ul>
                </div >
            </DefaultLayout >
        </>
    );
};

export default Area;